import React, { useState } from 'react'
import theme from '../../utils/themes'
import { formateLocalNumber, getCurrencySign, toTitleCase, useWindowSize } from '../../utils/helper';
import PropTypes from 'prop-types';
import OccyLogoBlue from '../../app/components/svgIcons/OccyLogoBlue';
import { StyledLabel } from '../../assets/styledComponents/Global';
import LocationIcon from '../../app/components/svgIcons/LocationIcon';
import CompanyProfileIcon from '../../app/components/svgIcons/CompanyProfileIcon';
import JobsIcon from '../../app/components/svgIcons/JobsIcon';
import styled from 'styled-components';
import { getAddressStringByGoogleLocation } from '../job/creation/assets/jobCreationUtill';
import WalletIcon from '../../app/components/svgIcons/WalletIcon';
import EmailIcon from '../../app/components/svgIcons/EventsIcon/EmailIcon';
import CallIcon from '../../app/components/svgIcons/CallIcon';
import CandidateIconFill from '../../app/components/svgIcons/CandidateIconFill';
export function htmlToPlainText(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
}
const CompanyInfoSideBar = ({ background, companyInfo, component }) => {

    const isSmallScreen = useWindowSize();
    const [expanded, setExpanded] = useState(false);

    const ReadMoreText = (html, limit = 150) => {

        const text = htmlToPlainText(html);
        const isLong = text.length > limit;
        const ellipsis = isLong ? "..." : "";
        const displayText = expanded ? text : text.slice(0, limit) + ellipsis;

        return (
            <div>
                <span>{displayText}</span>
                {isLong && (
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className="btn btn-link p-0 ms-1"
                        style={{ fontSize: "14px" }}
                    >
                        {expanded ? "Read Less" : "Read More"}
                    </button>
                )}
            </div>
        );
    };

    const hiringPlan = component === 'Referee' || component === 'RefereeForm' ? companyInfo?.application?.job?.jobHiringPlan[0] : companyInfo?.data?.applicationSourceTracking?.jobHiringPlan;
    const company = component === 'Referee' || component === 'RefereeForm' ? companyInfo?.company : companyInfo?.data?.job?.company;
    const candidate = companyInfo?.application?.candidate;
    // --------------------
    // Extracted logic here
    // --------------------
    const renderSalary = () => {
        const hp = hiringPlan;

        if (!Number(hp?.salaryFrom) > 0) {
            return "Competitive/negotiable";
        }

        // Case: Only salaryFrom present and not competitive
        if (hp?.salaryFrom && !hp?.salaryTo && !hp?.isCompetitive) {
            return formateLocalNumber(hp?.salaryFrom);
        }

        // Case: Non-competitive full range
        if (
            hp?.isCompetitive === 0 &&
            hp?.salaryFrom > 0 &&
            hp?.salaryTo > 0
        ) {
            const currency = getCurrencySign(hp?.salaryCurrency);

            // salaryFrom == salaryTo
            if (hp.salaryFrom === hp.salaryTo) {
                return (
                    formateLocalNumber(hp.salaryFrom) +
                    (hp?.salaryPeriod ? " per " + hp.salaryPeriod : "")
                );
            }

            // salaryFrom != salaryTo
            return (
                formateLocalNumber(hp.salaryFrom) +
                " - " +
                currency +
                formateLocalNumber(hp.salaryTo) +
                " per " +
                (hp?.salaryPeriod ?? "")
            );
        }

        // Case: only salaryTo exists and not competitive
        if (hp?.salaryTo > 0 && hp?.isCompetitive === false) {
            return (
                formateLocalNumber(hp?.salaryFrom) +
                " " +
                (hp?.salaryPeriod ?? "")
            );
        }

        // Default empty
        return "";
    };



    return (
        <CompanyInfoSideB background={background}>

            {!isSmallScreen && company?.compLOGOSignedUrl ?
                <img
                    className='mb-3'
                    src={company?.compLOGOSignedUrl}
                    alt={company?.compLOGOSignedUrl || 'image'}
                /> :
                !isSmallScreen && <OccyLogoBlue className='mb-3' />
            }
            <div className={isSmallScreen ? 'd-flex flex-column bg-white px-3 py-2' : 'd-flex flex-column'}>

                <StyledLabel size='18px' weight='500' color='#121212CC' className='mb-2'>{component === 'RefereeForm' ? 'Candidate' : 'Job'} Details    </StyledLabel>
                <StyledLabel size='22px' weight='400' color={theme?.darktext} className='mb-2 font-fredoka fw-normal'> {component === 'Referee' ? companyInfo?.application?.job?.title : component === 'RefereeForm' ? candidate?.firstName + " " + candidate?.lastName : companyInfo?.data?.job?.title} </StyledLabel>
            </div>

            <div className={isSmallScreen && 'p-2 h-100'}>
                <div className={isSmallScreen && 'bg-white p-2 rounded h-100'}>

                    <StyledLabel size='14px' weight='500' color={theme?.subText} style={{ height: expanded && '300px' }} className={`mb-4 overflow-y-auto ${isSmallScreen && 'mt-3'}`}>  {ReadMoreText(component === 'Referee' ? companyInfo?.application?.job?.jobDescription : component === 'RefereeForm' ? `${candidate?.firstName+" " + candidate?.lastName} is the person who send you this refernce check form` : companyInfo?.data?.job?.jobDescription ?? '-', 300)}    </StyledLabel>

                    {component === 'RefereeForm' &&
                        <div className='d-flex align-items-center gap-2 mb-3'>
                            <IconBg >
                                <EmailIcon className={'text-primary'} size='18' />
                            </IconBg>
                            <StyledLabel size='14px' weight='500' color={theme?.darktext}> {candidate?.email}    </StyledLabel>

                        </div>}

                    {component === 'RefereeForm' &&
                        <div className='d-flex align-items-center gap-2 mb-3'>
                            <IconBg >
                                <CallIcon className={'text-primary'} size='18' />
                            </IconBg>
                            <StyledLabel size='14px' weight='500' color={theme?.darktext}> {candidate?.phone || '-'}    </StyledLabel>

                        </div>}

                    <div className='d-flex align-items-center gap-2 mb-3'>
                        <IconBg >
                            <LocationIcon size='18' />
                        </IconBg>
                        <StyledLabel size='14px' weight='500' color={theme?.darktext}> {getAddressStringByGoogleLocation(hiringPlan?.centralLocation, ['address', 'postaltown', 'postalCode'])}    </StyledLabel>

                    </div>

                    {component === 'RefereeForm' &&
                        <div className='d-flex align-items-center gap-2 mb-3'>
                            <IconBg >
                                <CandidateIconFill className={'text-primary'} size='18' />
                            </IconBg>
                            <StyledLabel size='14px' weight='500' color={theme?.darktext}> {companyInfo?.appForm?.refereeMeta?.opts?.relation}    </StyledLabel>

                        </div>}

                    {component !== 'RefereeForm' &&

                        <div className='d-flex text-primary align-items-center gap-2 mb-3'>
                            <IconBg>
                                <CompanyProfileIcon className={'text-primary'} size='18' />
                            </IconBg>
                            <StyledLabel size='14px' weight='500' color={theme?.darktext}> {company?.name} </StyledLabel>

                        </div>}
                    {component !== 'RefereeForm' &&

                        <div className='d-flex align-items-center gap-2 mb-3'>
                            <IconBg>  <JobsIcon color={theme?.primary} size={18} />  </IconBg>
                            <StyledLabel size='14px' weight='500' color={theme?.darktext}>{toTitleCase(hiringPlan?.jobType ?? '-')} </StyledLabel>

                        </div>}
                    {component !== 'RefereeForm' &&
                        <div className='d-flex align-items-center gap-2 mb-3'>
                            <IconBg>
                                <WalletIcon size={18} />
                            </IconBg>
                            <StyledLabel size="14px" weight="500" color={theme?.darktext}>
                                {hiringPlan?.salaryFrom && hiringPlan?.isCompetitive === 0
                                    ? getCurrencySign(hiringPlan?.salaryCurrency)
                                    : " "}
                                {renderSalary()}
                            </StyledLabel>

                        </div>}

                </div>
            </div>

            {/* <div className='d-flex align-items-center gap-2 mb-3'>
          <IconBg>
            <GlobeIcon size='18px' />
          </IconBg>
          <StyledLabel size='14px' weight='500' color={theme?.darktext}> www.prolineinvent.com  </StyledLabel>

        </div> */}

        </CompanyInfoSideB>
    )
}
CompanyInfoSideBar.propTypes = {
    background: PropTypes.string,
    companyInfo: PropTypes.shape({
        data: PropTypes.object,
    }),
};

export default CompanyInfoSideBar


const CompanyInfoSideB = styled.div`
  display: flex;
  flex-direction: column;
  width: 337px;
  padding: 40px 30px 20px 27px;

  ${({ background, isSmallScreen, open }) => {
        const transformValue = open ? 'translateX(0)' : 'translateX(-100%)';
        const backgroundColor = background ?? '';
        return isSmallScreen
            ? `
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        padding: 0px;
        background: ${theme?.bodyBg};
        box-shadow: 2px 0 8px rgba(0,0,0,0.15);
        transition: transform 0.3s ease-in-out;
        z-index: 1050;
        transform: ${transformValue};
      `
            : `
        background: ${backgroundColor};
        position: relative;
        height: auto;
        box-shadow: none;
        transform: none;
      `;
    }}
`;

const IconBg = styled.div`
display:flex;
align-items:center;
justify-content:center;
width: 30px;
height: 30px;
angle: 0 deg;
opacity: 1;
border-radius: 107.69px;
background:  ${({ isSmallScreen }) => isSmallScreen ? theme?.bodyBg : '#fff'};
color:${theme?.primary};
`